/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Zip_QueuedInputs */

const cs_documents_zip_queued = /** @type {(inputs: Documents_Zip_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP zařazen`)
};

const en_documents_zip_queued = /** @type {(inputs: Documents_Zip_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP queued`)
};

/**
* | output |
* | --- |
* | "ZIP queued" |
*
* @param {Documents_Zip_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_zip_queued = /** @type {((inputs?: Documents_Zip_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Zip_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_zip_queued(inputs)
	return cs_documents_zip_queued(inputs)
});